import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';
import { CrntIcon } from '@essent/current-web-angular';

@Component({
  selector: 'wl-offer-usps',
  templateUrl: './offer-usps.component.html',
  styleUrls: [],
  standalone: true,
  imports: [CommonModule, CSCaptureDirective, CrntIcon],
})
export class OfferUspsComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() usps: string[] = [];
}
